import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import * as ReactSwipe from 'react-swipe'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { Text, Inline, Stack, Colors } from '@doordash/design-language'
import Button, { IconButton } from '@doordash/component-button'
import NavBar from '@doordash/component-navbar'
import Pagination from '@doordash/component-pagination'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import { BASE_GROWTH_IMAGE_CDN, FIRST_DASH_PATH } from '../../../constants'
import { FixedBottomContainer } from '../../atoms/fixed-bottom-container'

import { ContentImageContainer, ContentContainer } from './styles'
import { ActivatedNoFirstDashSlide } from './content'
import t from './strings'
import routes from '../../../routes'

type ActivatedNoFirstDashContainer = {
  slides: ActivatedNoFirstDashSlide[]
  locale?: string
  track?: (
    name: DA.EventActions,
    page: DA.ActivatedNoFirstDashScreens,
    data?: object
  ) => Promise<void>
}
const SlideContainer = styled.div`
  height: 100%;
`

export const ActivatedNoFirstDashContainer: React.FC<ActivatedNoFirstDashContainer &
  RouteComponentProps> = ({ slides, track, history }) => {
  const [index, setIndex] = React.useState(0)
  const canNavigate = slides.length - 1 > index

  React.useEffect(() => {
    track(DA.EventActions.Rendered, slides[index].key)
  }, [])

  const onBackNavigationClick = () => {
    track(DA.EventActions.Clicked, slides[index].key)
    setIndex(index - 1)
  }

  const onNextNavigationClick = () => {
    track(DA.EventActions.Clicked, slides[index].key)
    setIndex(index + 1)
  }

  const onSwipe = i => {
    track(
      i + 1 > index ? DA.EventActions.Next : DA.EventActions.Back,
      slides[index].key
    )
  }

  const onNavigateToDashPage = () => {
    track(DA.EventActions.Clicked, slides[index].key, { name: 'primary' })
    return history.push(routes.firstDashDash.path)
  }

  return (
    <React.Fragment>
      <ReactSwipe
        swipeOptions={{
          continuous: false,
          startSlide: index,
          transitionEnd: i => setIndex(i),
          callback: i => onSwipe(i),
        }}
      >
        {slides.map(({ key, title, subtitle, content }) => {
          const imageUrl = `${BASE_GROWTH_IMAGE_CDN}${FIRST_DASH_PATH}/${key}/en.png`
          return (
            <SlideContainer key={key}>
              <ContentImageContainer url={imageUrl} />
              <Pagination
                shape={Pagination.Shapes.Dot}
                size={Pagination.Sizes.Small}
                selectedIndex={index}
                count={slides.length}
              />
              <Inline>
                <ContentContainer>
                  <Stack>
                    <Text
                      styles={Text.Styles.Caption1}
                      color={Colors.SystemGrey60}
                    >
                      {subtitle}
                    </Text>
                    <Text styles={Text.Styles.PageTitle2}>{title}</Text>
                  </Stack>
                  {content}
                </ContentContainer>
              </Inline>
            </SlideContainer>
          )
        })}
      </ReactSwipe>
      <FixedBottomContainer>
        <Stack size={Stack.Sizes.Large}>
          {canNavigate ? (
            <NavBar
              navigationType={
                index === 0
                  ? NavBar.NavigationTypes.None
                  : NavBar.NavigationTypes.Back
              }
              onNavigationClick={onBackNavigationClick}
              actions={[
                {
                  accessibilityLabel: 'next',
                  iconType: IconButton.IconTypes.ArrowRight,
                  onClick: onNextNavigationClick,
                },
              ]}
              isSeparatorVisible={false}
            />
          ) : (
            <ContentContainer>
              <Inline>
                <Button
                  onClick={onNavigateToDashPage}
                  size={Button.Sizes.Large}
                >
                  {t.getStarted()}
                </Button>
              </Inline>
            </ContentContainer>
          )}
        </Stack>
      </FixedBottomContainer>
    </React.Fragment>
  )
}

const mapDispatchToProps = {
  track: events.trackActivatedNoFirstDash,
}

export default connect(null, mapDispatchToProps)(ActivatedNoFirstDashContainer)
